import { apiClient } from '@/lib/api-client'

export interface ReferralStats {
  referralCode: string
  referralUrl: string
  qrCodeUrl: string
  stats: {
    totalClicks: number
    conversions: number
    conversionRate: number
    merchants: number
  }
  recentClicks: any[]
  recentMerchants: any[]
}

export const referralService = {
  async getStats(token: string): Promise<ReferralStats> {
    return await apiClient.get<ReferralStats>('/referrals/stats', token)
  },

  async getReferral(token: string): Promise<{ referralCode: string; referralUrl: string }> {
    return await apiClient.get('/scouts/me/referral', token)
  },
}
